import PreviewSidebar from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar";
import PreviewArea from "containers/admin/clients/client/theme-page/preview/preview-area/preview-area";

import { FONTS_TAB_SIDEBAR } from "containers/admin/clients/client/theme-page/preview/sub-tabs/fonts/fonts.constants";

import Icons from "assets";

const Fonts = () => {
  return (
    <>
      <PreviewSidebar
        sidebarInfoWarning={
          <div className="flex p-2 gap-1 rounded-md border border-neutrals-200">
            <Icons.ExclamationCircle className="h-4 w-4 text-gray-600 shrink-0" />
            <p className="text-sm">
              Changing these parameters may affect the configurations using it.
            </p>
          </div>
        }
        sidebarItems={FONTS_TAB_SIDEBAR}
      />
      <div className="flex-1 overflow-auto custom-scroll">
        <PreviewArea />
      </div>
    </>
  );
};

export default Fonts;
